<div class="container" (click)="select()">
  <div class="img-container">
    <img
      [ngClass]="{
        active: model === value,
        disabled: ngControl.disabled,
        correct: styleClass === 'correct',
        error: styleClass === 'error',
      }"
      [src]="img"
    />
    @if (styleClass === 'correct') {
      <span class="style-icon" inlineSVG="/icons/icon-success-4.svg"></span>
    }
    @if (styleClass === 'error') {
      <span class="style-icon" inlineSVG="/icons/icon-cancel-dark-red.svg"></span>
    }
  </div>
</div>
